import { lazy } from "react";
import Loadable from "app/components/Loadable";

const ElementCode = Loadable(lazy(() => import("./ElementCode")));

const elementcodeRoute = [{ path: "/element-code", element: <ElementCode /> }];
export default elementcodeRoute;
